import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    const legalLinks = [
        { href: '/terms', label: 'Terms of Service' },
        { href: '/privacy', label: 'Privacy Policy' },
        { href: '/acceptable-use', label: 'Acceptable Use' },
        { href: '/content-guidelines', label: 'Content Guidelines' },
        { href: '/community-standards', label: 'Community Standards' },
        { href: '/ownership-reset-policy', label: 'Ownership Reset Policy' },
    ];

    const companyLinks = [
        { href: '/about', label: 'About ClientCheck' },
        { href: '/contact', label: 'Contact / Support' },
    ];

    return (
        <footer className="border-t border-border bg-background mt-auto">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
                {/* Main Footer Content */}
                <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-8">
                    {/* Brand Section */}
                    <div className="md:col-span-5">
                        <Logo variant="full" size="small" />
                        <p className="mt-4 text-sm text-muted-foreground max-w-sm leading-relaxed">
                            ClientCheck helps contractors document job experiences professionally and make smarter business decisions.
                        </p>
                    </div>

                    {/* Legal Links */}
                    <div className="md:col-span-4">
                        <h4 className="font-semibold text-foreground text-sm mb-4">Legal & Policies</h4>
                        <ul className="space-y-2">
                            {legalLinks.map((link) => (
                                <li key={link.href}>
                                    <Link 
                                        to={link.href}
                                        className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                                    >
                                        {link.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Company Links */}
                    <div className="md:col-span-3">
                        <h4 className="font-semibold text-foreground text-sm mb-4">Company</h4>
                        <ul className="space-y-2">
                            {companyLinks.map((link) => (
                                <li key={link.href}>
                                    <Link 
                                        to={link.href}
                                        className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                                    >
                                        {link.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="border-t border-border pt-6">
                    <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
                        <p className="text-xs text-muted-foreground">
                            &copy; {currentYear} ClientCheck. All rights reserved.
                        </p>
                        <p className="text-xs text-muted-foreground text-center sm:text-right max-w-lg">
                            ClientCheck provides a platform for structured job experience documentation. 
                            Users are responsible for the accuracy of content they submit.
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
